import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { IFeedbackTransaction } from '../../builders/plan_feedback_transaction_builder';
import { planFeedbackTransactionActionType } from '../../builders/plan_feedback_transaction_type';
import { FeedbackSuggestedPlanModel } from '../../models/feedback_suggested_plan_model';
import {
  ApPlanFeedbackDeEmphasizeEventNameStrategy,
  ApPlanFeedbackEmphasizeEventNameStrategy
} from '../../strategies/plan_feedback_highlight_event_name_strategy';

class PlanFeedbackAcceptReject {
  private feedback: IFeedbackTransaction;
  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private $element: ng.IAugmentedJQuery,
    private performActionOnFeedbackHelper: ng.IServiceProviderFactory
  ) {}

  performAcceptDecline(actionType: planFeedbackTransactionActionType) {
    this.performActionOnFeedbackHelper([this.feedback], actionType, [this.feedback.transactionNK], this.feedback.type);
  }
  declineClicked() {
    this.performAcceptDecline('REJECT');
  }

  acceptClicked() {
    this.performAcceptDecline('ACCEPT');
  }

  emphasizeSuggestionTileInTerm($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.$element.find('.plan-feedback-accept-reject').addClass('ap-plan-feedback-hover-class');
    if (!ApPlanFeedbackEmphasizeEventNameStrategy.includes(this.feedback.type)) {
      return;
    }
    this.ngComponentCommunicatorService.publish(
      ApPlanFeedbackEmphasizeEventNameStrategy[this.feedback.type](this.feedback.transactionNK)
    );
  }
  deEmphasizeSuggestionTileInTerm($event: any) {
    this.$element.find('.plan-feedback-accept-reject').removeClass('ap-plan-feedback-hover-class');
    if (!ApPlanFeedbackDeEmphasizeEventNameStrategy.includes(this.feedback.type)) {
      return;
    }
    this.ngComponentCommunicatorService.publish(
      ApPlanFeedbackDeEmphasizeEventNameStrategy[this.feedback.type](this.feedback.transactionNK)
    );
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackAcceptReject', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_accept_reject/plan_feedback_accept_reject.html',
  controller: PlanFeedbackAcceptReject,
  bindings: {
    feedback: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_accept_reject/plan_feedback_accept_reject.ts